import { render, staticRenderFns } from "./SkupPromet.vue?vue&type=template&id=16f2eb51&scoped=true&"
import script from "./SkupPromet.vue?vue&type=script&lang=js&"
export * from "./SkupPromet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f2eb51",
  null
  
)

export default component.exports